/**
 * Created by neo on 16.09.21.
 */
import { makeAutoObservable } from 'mobx';
import { LocalizedEntity, createLocalizedEntityFields } from '../LocalizedEntity';

export type ProgramTemplateResult = LocalizedEntity;

export function createProgramTemplateResult(json?: Partial<ProgramTemplateResult>): ProgramTemplateResult {
  return makeAutoObservable(createLocalizedEntityFields(json));
}
